const PAYCHECK_ENDPOINTS = {
  LIST: "/frontend/paycheck-scenarios",
  CREATE: "/frontend/paycheck-scenarios",
  UPDATE: (id) => `/frontend/paycheck-scenarios/${id}`,
  REMOVE: (id) => `/frontend/paycheck-scenarios/${id}`,
  DUPLICATE: (id) => `/frontend/paycheck-scenarios/${id}/duplicate`,
  VIEW: (id) => `/frontend/paycheck-scenarios/${id}/view`,
  CALCULATE: "/public/paycheck-calculator/calculate",
  USAGE: "/frontend/paycheck-calculator/usage",
};

export default PAYCHECK_ENDPOINTS;
